import { Spacer, Text } from "@zapier/design-system";
import MediaSlideshow, {
  MediaItem,
} from "src/components/MediaSlideshow/MediaSlideshow";
import { TemplateDetailPageCTAs } from "src/components/TemplateDetailPage/TemplateDetailPageCTAs";
import { ZapBreakdown } from "src/components/ZapBreakdown/ZapBreakdown";
import { ZapCardTemplate } from "src/components/ZapCard";
import styles from "./TemplateDetailHeroSection.module.css";
import { ZapBreakdownDetails } from "src/components/TemplateDetail/types";
import { ZapBreakdownSkeleton } from "src/components/ZapBreakdown/ZapBreakdownSkeleton";

type TemplateDetailHeroSectionProps = {
  template: ZapCardTemplate;
  zapBreakdownDetails: ZapBreakdownDetails | null;
  isLoggedIn?: boolean;
  isDraftModeEnabled?: boolean;
  isModal?: boolean;
};

export const TemplateDetailHeroSection = ({
  template,
  isLoggedIn = false,
  isDraftModeEnabled = false,
  zapBreakdownDetails,
  isModal = false,
}: TemplateDetailHeroSectionProps) => {
  const mediaItems: MediaItem[] = template.previewImage
    ? [
        {
          type: "image",
          src: template.previewImage.url,
          alt: template.previewImage.title,
        },
        ...(template.additionalMedia?.map(
          (media): MediaItem => ({
            type: media.contentType?.includes("image") ? "image" : "video",
            src: media.url,
            alt: media.title,
          }),
        ) ?? []),
      ]
    : [];

  return (
    <div className={`${styles.heroContent} ${isModal ? styles.modal : ""}`}>
      <div className={styles.heroContentLeft}>
        <Text
          tag="h1"
          type={isModal ? "SectionHeader" : "PageHeader"}
          className={isModal ? styles.modalTitle : styles.title}
        >
          {template.name} {isDraftModeEnabled && "(Draft)"}
        </Text>
        <Spacer height={16} />
        <Text tag="p" type="Body1Multiline" color="TextDefault">
          {template.description}
        </Text>
        {template.description && <Spacer height={20} />}
        <TemplateDetailPageCTAs template={template} isLoggedIn={isLoggedIn} />
      </div>
      <div className={styles.heroContentRight}>
        {mediaItems.length > 0 ? (
          <MediaSlideshow mediaItems={mediaItems} />
        ) : zapBreakdownDetails ? (
          <ZapBreakdown
            title={zapBreakdownDetails.title}
            firstStep={zapBreakdownDetails.firstStep}
            lastStep={zapBreakdownDetails.lastStep}
            totalStepCount={zapBreakdownDetails.totalStepCount}
            services={zapBreakdownDetails.services}
            servicesList={zapBreakdownDetails.servicesList}
          />
        ) : (
          <ZapBreakdownSkeleton />
        )}
      </div>
    </div>
  );
};
